export default __webpack_public_path__ + "static/bt-screen-android-mobile-de4962dca1611d4f8122e5948a2350e4.webp";